import React from 'react'
import { RouteComponentProps, useParams } from 'react-router'

import { ProjectType, useProject } from '@lopo-tech/lopo-api'
import BackbuttonHeader from 'src/components/header/common/backbutton_header/backbutton_header'
import ProjectMap from 'src/components/map/project_map/project_map'
import { DETAIL_IMAGE_HEIGHT, DETAIL_IMAGE_WIDTH } from 'src/constants/image'
import { getProjectRoutes } from 'src/constants/urls'
import StandardPageTitle from 'src/containers/smart_components/page_title/page_title'
import { textResources } from 'src/lang/de'
import LayoutNoMap from 'src/layout/layout_no_map'
import { UrlUtils } from 'src/utils/url/url'
import './project_detail_map.scss'

const t = textResources.projects

interface IProps extends RouteComponentProps {
  projectType: ProjectType;
}

export const ProjectDetailMapPage: React.FC<IProps> = ({ history, projectType }) => {
  const { slug } = useParams<{ slug: string }>()
  const routes = getProjectRoutes(projectType)
  const { data } = useProject({
    variables: {
      slug,
      height: DETAIL_IMAGE_HEIGHT,
      width: DETAIL_IMAGE_WIDTH
    }
  })

  const fallbackRoute = routes.detail(slug)
  const projectName = data?.project?.name || t.details.nameFallback
  const project = data?.project

  return (
    <LayoutNoMap
      subHeader={
        <BackbuttonHeader
          title={projectName}
          handleBackButton={() => UrlUtils.goBack(history, fallbackRoute)}
        />
      }
      pageTitle={
        <StandardPageTitle
          text={
            projectType === ProjectType.InfrastructureProject
              ? t.common.infrastructureProjects
              : t.common.projects
          }
          showLocation
        />
      }
      withHeaderMargin={false}
    >
      <div className='project-detail-map'>
        {project?.geojson && (
          <ProjectMap
            geojson={project.geojson}
            boundingBox={project.boundingBox ?? undefined}
            center={project.boundingBox?.center ?? undefined}
          />
        )}
      </div>
    </LayoutNoMap>
  )
}

const PublicParticipationProjectDetailMapPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectDetailMapPage {...props} projectType={ProjectType.PublicParticipationProject} />
)

export default PublicParticipationProjectDetailMapPage
